import React, { useEffect, useState } from "react";
import emptyList from "../utils/emptyList.png";
import expand from "../utils/expand.png";
import products from "../utils/products.png";
import Drawer from "./Drawer";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbs } from "../modals/BreadcrumbsContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem, IconButton } from "@mui/material";
import deleteIcon from "../utils/delete.png";
import { ThemeProvider, createTheme } from "@mui/material/styles";




const KanbanViewQualified = ({ rows, setRows }) => {
  console.log("rows in kanban qualified:", rows);
  const [selectedLead, setSelectedLead] = useState(null); // Store selected lead for Drawer
  const [showDrawer, setShowDrawer] = useState(false);
  const [qualifiedLeads, setQualifiedLeads] = useState(
    JSON.parse(localStorage.getItem("qualifiedLeads"))?.map((lead) => ({
      ...lead,
      stage: lead.stage || "new",
    })) || [] // Fetch leads from localStorage
  );

  // useEffect(() => {
  //   localStorage.setItem("qualifiedLeads", JSON.stringify(qualifiedLeads));
  // }, [qualifiedLeads]);

  // Group leads by stage
  const groupedLeads = (qualifiedLeads || []).reduce((acc, lead) => {
    acc[lead.stage] = acc[lead.stage] || [];
    acc[lead.stage].push(lead);
    return acc;
  }, {});
  console.log("groupedLeads:", groupedLeads);

  // Handle drag-and-drop start
  const onDragStart = (e, leadId, fromStage) => {
    e.dataTransfer.setData("leadId", leadId);
    e.dataTransfer.setData("fromStage", fromStage);
  };

  // Handle drop event
  const onDrop = (e, newStage) => {
    const leadId = e.dataTransfer.getData("leadId");
    const fromStage = e.dataTransfer.getData("fromStage");

    if (!leadId || !fromStage || fromStage === newStage) return;

    // Update lead stage after drop
    setQualifiedLeads((prevLeads) =>
      prevLeads.map((lead) =>
        lead.id === parseInt(leadId, 10) ? { ...lead, stage: newStage } : lead
      )
    );
  };

  // Allow dropping into the columns
  const allowDrop = (e) => {
    e.preventDefault();
  };

  const viewLead = (id) => {
    handleKebabMenuClose();
    const lead = qualifiedLeads.find((lead) => lead.id === id);
    setSelectedLead(lead);
    setShowDrawer(true); // Show Drawer
  };

  const handleSave = (e) => {
    e.preventDefault();
    const updatedLeads = qualifiedLeads.map((lead) =>
      lead.id === selectedLead.id ? selectedLead : lead
    );
    setQualifiedLeads(updatedLeads);
    //localStorage.setItem("qualifiedLeads", JSON.stringify(updatedLeads));
    setShowDrawer(false); // Close Drawer after saving
  };

  const handleInputChange = (e, field) => {
    setSelectedLead((prevLead) => ({
      ...prevLead,
      [field]: e.target.value,
    }));
  };


  const stageClasses = {
    new: "bg-yellow-500",
    discovery: "bg-teal-500",
    proposal: "bg-sky-500",
    // negotiation: "bg-orange-600",
    sample: "bg-orange-600",
    ordersForApproval: "bg-green-600",
    // won: "bg-green-600",
    // lost: "bg-red-600",
  };

  // const stageMapping = {
  //   new: "New",
  //   discovery: "Discovery",
  //   proposal: "Proposal",
  //   negotiation: "Negotiation",
  //   // won: "Won",
  //   // lost: "Lost",
  // };

  const stageMapping = {
    new: "New",
    discovery: "Quotations Under Process",
    proposal: "Quotations For Approval",
    // negotiation: "Negotiation",
    sample: "Sample",
    ordersForApproval: "Orders For Approval",
    // won: "Won",
    // lost: "Lost",
  };

  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };

  const { showBreadcrumbs, setShowBreadcrumbs } = useBreadcrumbs();

  const navigate = useNavigate();

  const [quoteLeadId, setQuoteLeadId] = useState("");

  const handleQuoteButtonClick = (leadId) => {
    setQuoteLeadId(leadId);
    console.log("handleQuoteButtonClick = (leadId):", leadId);
    navigate(`/qualifiedLeadsTable/quoteLead/${leadId}`);
    if (setShowDrawer) setShowDrawer(false);
    setShowBreadcrumbs(true);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleKebabMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleKebabMenuClose = () => {
    setAnchorEl(null);
  };



  const handleDeleteLead = (lead) => {
    console.log("handleDeleteLead:", lead);
    handleKebabMenuClose();
    // setSelectedLead(lead);
    // // setViewLeadModal(true);
    // onDeleteChecked()
  };

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });

  return (
    <div className="flex gap-4 p-0   ">
      {Object.keys(stageMapping).map((stage, index) => (
        <div
          key={`${stage}-${index}`}
          className="flex-1 bg-gray-100 rounded shadow-md  w-[200px] mt-2 "
          onDragOver={allowDrop}
          onDrop={(e) => onDrop(e, stage)}
        >
          {/* stage Header */}
          <h2
            className={`text-md font-normal rounded-t text-center  p-2 text-white ${stageClasses[stage]}`}
          >
            {stageMapping[stage]}
          </h2>

          {/* Kanban Column Content */}
          <div className=" flex flex-col gap-2 py-0 h-[90vh]  overflow-y-auto scrollbar-hide   ">
            {groupedLeads[stage]?.map((lead) => (
              <div
                key={`${stage}-${lead.id}`}
                className="bg-white shadow-md p-2 m-2 rounded cursor-grab active:cursor-grabbing opacity-1 "
                draggable
                onDragStart={(e) => {
                  e.currentTarget.classList.add("dragging");
                  e.currentTarget.style.opacity = "1";
                  onDragStart(e, lead.id, lead.stage);
                }}
                onDragEnd={(e) => {
                  e.currentTarget.classList.remove("dragging");
                  e.currentTarget.style.opacity = "1";
                }}
              >
                <div className="flex justify-between items-center">
                  <h3 className="font-normal">{lead.lead}</h3>
                  <div className="flex justify-center items-center gap-1">
                    <div>
                      {lead.leadIsItemAdded && (
                        <img
                          src={products}
                          alt="products-icon"
                          className="w-1 h-1 bg-green-500 text-xs p-1 rounded-lg m-1"
                        />
                      )}
                    </div>


                    <div>
                      <ThemeProvider theme={theme}>
                        <IconButton
                          onClick={handleKebabMenuClick}
                          sx={{ padding: "0px" }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          sx={{
                            "& .MuiPaper-root": {
                              boxShadow:
                                "0px 2px 2px 0px rgba(100, 100, 111, 0.2)",
                            },
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleKebabMenuClose}
                        >
                          <MenuItem onClick={handleKebabMenuClose}>
                            <div
                              onClick={() => handleDeleteLead(lead)}
                              className="flex justify-between items-center gap-2"
                            >
                              <span>Delete</span>
                              <img
                                src={deleteIcon}
                                alt="delete-icon"
                                className="w-4 h-4 cursor-pointer"
                              />
                            </div>
                          </MenuItem>
                          {/* <MenuItem onClick={() => handleViewLead(lead)}> */}
                          <MenuItem onClick={() => viewLead(lead.id)}>
                            <div
                              
                              className="flex justify-between items-center gap-2 "
                            >
                              <span>View</span>

                              <img
                                src={expand}
                                alt="expand-icon"
                                className="w-4 h-4 cursor-pointer"
                              />
                            </div>
                          </MenuItem>
                        </Menu>
                      </ThemeProvider>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600">
                  {lead.organization || "No organization"}
                </p>

                <p className="text-sm text-gray-600">
                  {lead.title || "No title"}
                </p>
                <p className="text-sm text-gray-600 text-ellipsis overflow-hidden">
                  {lead.email || "No email"}
                </p>
                <p className="overflow-hidden text-ellipsis  text-xs text-center font-thin bg-gray-400 px-0.5 mt-2 rounded-lg text-white">
                  {calculateAgedDays(lead.leadEntryTime)}
                </p>
              </div>
            ))}

            {!groupedLeads[stage]?.length && (
              <div className="flex flex-col justify-center items-center  text-gray-500">
                <img src={emptyList} alt="No leads" className="w-32 h-24" />
                <p className="text-gray-400 pb-2 text-center">
                  No Qualified Leads
                </p>
              </div>
            )}
          </div>
        </div>
      ))}

      <Drawer
        showDrawer={showDrawer}
        setShowDrawer={setShowDrawer}
        selectedLead={selectedLead}
        handleInputChange={handleInputChange}
        handleSave={handleSave}
        stageMapping={stageMapping}
        handleQuoteButtonClick={handleQuoteButtonClick}
      />
    </div>
  );
};

export default KanbanViewQualified;
